<div class="modal-content">
    <div class="modal-header">
        <app-connection-image [connectionType]="info.connectionType"
                              class="me-3"></app-connection-image>
        Move Connection
        <button type="button" class="btn-close p-4" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <div class="modal-body mb-0 pb-0" >
        <p *ngIf="data.connection.meters.length > 0" class="text-danger">
            This connection has active meters. Moving it will also move all associated meters and meter data.
            <span>Are you sure you want to continue?</span>
        </p>
    </div>
    <div class="row px-4 mt-0 ">
        <div class="col-12">
            <app-form-field label="New location" class="w-100">
                <app-search [minCharacters]="0" [(ngModel)]="this.location" required
                            [searchFunction]="searchLocation"
                            [inputFormatter]="refDataUtils.locationEntityFormatter"
                            dataKey="location.info.name"
                            placeholder="Search for a location"
                            class="w-100">
                </app-search>
            </app-form-field>
        </div>
    </div>
    <div class="modal-footer justify-content-between">
        <a type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</a>
        <button type="button" class="btn btn-primary" (click)="moveConnection()" data-bs-dismiss="modal">
            Move connection
        </button>
    </div>
</div>